export const PASSWORD_MIN_LENGTH = 8;

export const ROUTE_HOME = '/';

export const ROUTE_LOGIN = '/login';
export const ROUTE_REGISTER_USER = '/register/user';
export const ROUTE_REGISTER_FIRM = '/register/firm';
export const ROUTE_REGISTER_FIRM_OAUTH = '/register/firmoauth';
export const ROUTE_FORGOT_PASSWORD = '/forgot-password';
export const ROUTE_FORGOT_PASSWORD_THANK_YOU = '/forgot-password-thank-you';
export const ROUTE_RESET_PASSWORD = '/reset-password';
export const ROUTE_CHANGE_PASSWORD = '/change-password';
export const ROUTE_FACEBOOK_CALLBACK = '/facebook-callback';
export const ROUTE_INSTAGRAM_CALLBACK = '/instagram-callback';
export const ROUTE_MAILCHIMP_CALLBACK = '/mailchimp-callback';
export const ROUTE_KNOWLEDGE_BASES = '/knowledgebases';
export const ROUTE_CHANNELS = '/channels';
export const ROUTE_ROLES = '/roles';
export const ROUTE_CAMPAIGN_NEW = '/campaign';
export const ROUTE_CAMPAIGN_EDIT = '/campaign/';
export const ROUTE_CONTENT_NEW = '/content';
export const ROUTE_CONTENT_EDIT = '/content/';
export const ROUTE_KNOWLEDGE_BASE_EDIT = '/knowledgebase/';
export const ROUTE_PERSONA_NEW = '/persona';
export const ROUTE_PRODUCT_NEW = '/product';
export const ROUTE_PRODUCT_EDIT = '/product/';
export const ROUTE_SOURCE_CONTENT_NEW = '/sourcecontent';
export const ROUTE_SOURCE_CONTENT_EDIT = '/sourcecontent/';
export const ROUTE_WRITING_STYLE_NEW = '/writingstyle';
export const ROUTE_ROLE_NEW = '/role'
export const ROUTE_ROLE_EDIT = '/role/'
export const ROUTE_ASSET_NEW = '/asset';
export const ROUTE_ASSET_EDIT = '/asset/';


export const ROUTE_FIRM_SETTINGS = '/settings';
export const ROUTE_USERS = '/users';
export const ROUTE_USER_NEW = '/user';
export const ROUTE_USER_EDIT = '/user/';
export const ROUTE_TOPICS = '/topics';
export const ROUTE_TOPIC_NEW = '/topic';
export const ROUTE_TOPIC_EDIT = '/topic/';

export const ROUTE_BACK_OFFICE_HOME = '/bo';
export const ROUTE_BACK_OFFICE_LOGIN = '/bo/login';
export const ROUTE_BACK_OFFICE_RESET_PASSWORD = '/bo/reset-password';
export const ROUTE_FIRMS = '/bo/firms';
export const ROUTE_FIRM_EDIT = '/bo/firm/:id?';
export const ROUTE_FIRM_USER_EDIT = '/bo/firms/:firmId/users/:userId';
export const ROUTE_BILLING_METRICS = '/bo/billing';
export const ROUTE_BACK_OFFICE_USERS = '/bo/team';
export const ROUTE_BACK_OFFICE_USER = '/bo/team/:id?';
export const ROUTE_BACK_OFFICE_USER_NEW = '/bo/team/new';
export const ROUTE_BACK_OFFICE_USER_EDIT = '/bo/team/';
export const ROUTE_BACK_OFFICE_PROMPT_TEMPLATES = '/bo/prompts';
export const ROUTE_BACK_OFFICE_PROMPT_TEMPLATE = '/bo/prompt/:id?';
export const ROUTE_BACK_OFFICE_PROMPT_TEMPLATE_NEW = '/bo/prompt';
export const ROUTE_BACK_OFFICE_PROMPT_TEMPLATE_EDIT = '/bo/prompt/';
export const ROUTE_BACK_OFFICE_INSTRUCTION_BLOCKS = '/bo/instruction-blocks';
export const ROUTE_BACK_OFFICE_INSTRUCTION_BLOCK = '/bo/instruction-block/:id?';
export const ROUTE_BACK_OFFICE_INSTRUCTION_BLOCK_NEW = '/bo/instruction-block';
export const ROUTE_BACK_OFFICE_INSTRUCTION_BLOCK_EDIT = '/bo/instruction-block/';
export const ROUTE_BACK_OFFICE_RESOLVED_PROMPTS = '/bo/resolved-prompts';
export const ROUTE_BACK_OFFICE_CONTENT_VALIDATORS = '/bo/content-validators';
export const ROUTE_BACK_OFFICE_CONTENT_VALIDATOR = '/bo/content-validator/:id?';
export const ROUTE_BACK_OFFICE_CONTENT_VALIDATOR_NEW = '/bo/content-validator';
export const ROUTE_BACK_OFFICE_CONTENT_VALIDATOR_EDIT = '/bo/content-validator/';
export const ROUTE_BACK_OFFICE_CONTENT_TYPES = '/bo/contenttypes';
export const ROUTE_BACK_OFFICE_AGENT_PROMPTS = '/bo/agent-prompts';
export const ROUTE_BACK_OFFICE_SUPPORT_REQUESTS = '/bo/support-requests';
export const ROUTE_BACK_OFFICE_SUPPORT_REQUEST = '/bo/support-request/:id?';
export const ROUTE_BACK_OFFICE_SETTINGS = '/bo/settings';
export const ROUTE_BACK_OFFICE_CHANGE_PASSWORD = '/bo/change-password';
export const ROUTE_BACK_OFFICE_SYSTEM_SETTINGS = '/bo/system-settings';
export const ROUTE_BACK_OFFICE_SYSTEM_PROMPTS = '/bo/system-prompts';

export const ERROR_FOCUS_MODE = 'ERROR_FOCUSMODE_9A7Z';
export const ERROR_FOCUS_MODE_MESSAGE = 'Given context does not contain relevant content to generate output. Please uncheck "Limit to Provided Context" and try again.';

export const ENABLE_NEW_UI = import.meta.env.REACT_APP_ENABLE_NEW_UI === 'true';

export const DEFAULT_LANGUAGE = `American English`;

export const COMMAND_AI_FIX_GRAMMAR = 'FIX_GRAMMAR_SPELLING';
export const COMMAND_AI_IMPROVE_WRITING = 'IMPROVE_WRITING';
export const COMMAND_AI_USE_SIMPLE_LANGUAGE = 'USE_SIMPLE_LANGUAGE';
export const COMMAND_AI_MAKE_SHORTER = 'MAKE_SHORTER';
export const COMMAND_AI_MAKE_LONGER = 'MAKE_LONGER';
export const COMMAND_AI_SUMMARIZE = 'SUMMARIZE';
export const COMMAND_AI_ASK = 'ASK';
export const COMMAND_AI_TLDR = 'TLDR';
export const COMMAND_AI_FAQ = 'FAQ';
export const COMMAND_AI_META_TITLE = 'META_TITLE';
export const COMMAND_AI_META_DESCRIPTION = 'META_DESCRIPTION';
export const COMMAND_AI_META_SCHEMA_MARKUP = 'META_SCHEMA_MARKUP';
export const COMMAND_AI_TESTIMONIAL = 'TESTIMONIAL';
export const COMMAND_AI_RECOGNITION = 'RECOGNITION';
export const COMMAND_AI_AUTHOR_BIO_MAKE_SHORTER = 'AUTHOR_BIO_MAKE_SHORTER';
export const COMMAND_AI_AUTHOR_BIO_IMPROVE_WRITING = 'AUTHOR_BIO_IMPROVE_WRITING';
export const COMMAND_AI_AUTHOR_BIO_MAKE_LONGER = 'AUTHOR_BIO_MAKE_LONGER';
export const COMMAND_AI_AUTHOR_BIO_FIX_GRAMMAR = 'AUTHOR_BIO_FIX_GRAMMAR';

export const HIDDEN_CONTENT_COMMAND_MAP = {
  tldr: COMMAND_AI_TLDR,
  faq: COMMAND_AI_FAQ,
  testimonial: COMMAND_AI_TESTIMONIAL,
  recognition: COMMAND_AI_RECOGNITION,
};

export const AI_ASSISTANT_TITLE_FIX_GRAMMAR = 'Fix Spelling and Grammar';
export const AI_ASSISTANT_TITLE_IMPROVE_WRITING = 'Improve Writing';
export const AI_ASSISTANT_TITLE_USE_SIMPLE_LANGUAGE = 'Use Simpler Language';
export const AI_ASSISTANT_TITLE_MAKE_SHORTER = 'Make Shorter';
export const AI_ASSISTANT_TITLE_MAKE_LONGER = 'Make Longer';    
export const AI_ASSISTANT_TITLE_SUMMARIZE = 'Summarize';

export const SCREEN_NAME_CONTENT_OPTIMIZE = 'Content > Optimize';
export const SCREEN_NAME_CONTENT_OUTPUT = 'Content > Output';
export const SCREEN_NAME_SOURCE_CONTENT_OPTIMIZE = 'Model > Optimize';
export const SCREEN_NAME_SOURCE_CONTENT_OUTPUT = 'Model > Output';
export const SCREEN_NAME_KNOWLEDGE_BASE_ARTICLE = 'Knowledge Base > Article';
export const STATUS_FAILED = 'Autosave Failed';